// API Configuration
const API_CONFIG = {
    // Use production API URL
    BASE_URL: 'https://akselirajahalme.fi/backend/api',
    
    // API Endpoints
    ENDPOINTS: {
        GET_ALL_POSTS: '/get_blog_posts.php',
        GET_POST: '/get_blog_post.php',
        CREATE_POST: '/create_blog_post.php',
        UPDATE_POST: '/update_blog_post.php',
        DELETE_POST: '/delete_blog_post.php',
        GET_ALL_POSTS_ADMIN: '/get_all_blog_posts_admin.php',
        LOGIN: '/login.php',
        LOGOUT: '/logout.php'
    }
};

// Helper function to build API URLs
export const buildApiUrl = (endpoint, params = {}) => {
    let url = `${API_CONFIG.BASE_URL}${endpoint}`;
    
    // Add query parameters if provided
    if (Object.keys(params).length > 0) {
        const queryString = new URLSearchParams(params).toString();
        url += `?${queryString}`;
    }
    
    console.log('Building API URL:', url);
    return url;
};

export { API_CONFIG };
export default API_CONFIG;
